module.exports = __webpack_public_path__ + "img/Flyer_capacitacion_VenueSC48_BehringerX32.021d848d.jpg";